/**
 * FC Also Bought — slider + add-to-cart functionality
 * Uses MinimogLibs.Swiper (loaded via vendor.min.js) for the carousel.
 * Adds to cart via hidden form submission — SlideCart HQ intercepts
 * form[action="/cart/add"] submissions to update its React state and open.
 *
 * Developer: Alfie
 * Updated: 2026-03-17
 */
(function () {
  'use strict';

  function init() {
    initSlider();
    initAddToCart();
  }

  /* ------------------------------------------------------------------ */
  /*  SLIDER                                                             */
  /* ------------------------------------------------------------------ */

  function initSlider() {
    var swiperEl = document.querySelector('.fc-also-bought__swiper');
    if (!swiperEl) return;

    var slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    /* Swiper is exposed via MinimogLibs (vendor.min.js), not as a global */
    if (typeof MinimogLibs === 'undefined' || !MinimogLibs.Swiper) return;

    var SwiperClass = MinimogLibs.Swiper;

    new SwiperClass(swiperEl, {
      modules: [MinimogLibs.Swiper.Pagination],
      slidesPerView: 1,
      spaceBetween: 12,
      pagination: {
        el: '.fc-also-bought__pagination',
        clickable: true
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  ADD TO CART                                                        */
  /* ------------------------------------------------------------------ */

  function initAddToCart() {
    var buttons = document.querySelectorAll('.fc-also-bought__add-btn');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled || btn.dataset.loading === 'true') return;
        addToCart(btn);
      });
    });
  }

  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    /* Set loading state — CSS handles show/hide via data-loading */
    btn.dataset.loading = 'true';

    /* Create a hidden form that SlideCart HQ will intercept.
       SlideCart listens for form submissions to /cart/add and handles
       the AJAX request + drawer open + state update internally. */
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.style.display = 'none';

    var idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = variantId;
    form.appendChild(idInput);

    var qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '1';
    form.appendChild(qtyInput);

    var submitBtn = document.createElement('button');
    submitBtn.type = 'submit';
    form.appendChild(submitBtn);

    document.body.appendChild(form);

    /* Use button click to trigger the submit event
       (form.submit() bypasses event listeners, but click does not) */
    submitBtn.click();

    /* Clean up the form */
    document.body.removeChild(form);

    /* Watch for SlideCart to open (gets 'open' class) to clear loading,
       or fall back to a timeout if observer doesn't fire */
    var slidecart = document.querySelector('#slidecarthq > .slidecarthq');
    var cleared = false;

    function clearLoading() {
      if (cleared) return;
      cleared = true;
      btn.dataset.loading = 'false';
      btn.dataset.added = 'true';
      updateCartCount();
      setTimeout(function () {
        btn.dataset.added = 'false';
      }, 2000);
    }

    if (slidecart) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (slidecart.classList.contains('open') && !slidecart.classList.contains('cartEmpty')) {
            observer.disconnect();
            clearLoading();
            return;
          }
        }
      });
      observer.observe(slidecart, { attributes: true, attributeFilter: ['class'] });

      /* Fallback timeout in case observer doesn't catch it */
      setTimeout(function () {
        observer.disconnect();
        clearLoading();
      }, 3000);
    } else {
      /* No SlideCart element found — clear after short delay */
      setTimeout(clearLoading, 1500);
    }
  }

  function updateCartCount() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    fetch(root + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
        if (cart.item_count > 0) {
          el.textContent = cart.item_count;
          el.classList.remove('m:hidden');
        } else {
          el.classList.add('m:hidden');
        }
      });
    })
    .catch(function () {});
  }

  /* ------------------------------------------------------------------ */
  /*  INIT                                                               */
  /* ------------------------------------------------------------------ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
